import React from 'react';
import { useSelector } from 'react-redux';
import SpinnerBlocker from 'commons/src/components/modals/ModalSpinnerBlocker';
import ResponseBox from 'commons/src/components/responseMessages/ResponseBox';
import { ThresholdsResourceScope } from 'commons/src/models/commonEnums';
import { toErrorType } from 'commons/src/sagas/isErrorType';
import { useGetBuildingThresholdsQuery } from '../../../api';
import CustomThresholds from '../../account/thresholds/CustomThresholdSection';
import ThresholdMgmt from '../../account/thresholds/ThresholdMgmt';
import styles from './BuildingThresholds.module.scss';
import { makeCustomThresholdSelector } from './BuildingThresholdSelector';

type Props = {
    locationId: string;
};
const BuildingThresholds = ({ locationId }: Props): JSX.Element => {
    const customThresholds = useSelector(makeCustomThresholdSelector(locationId));
    const { data = {}, isLoading, error } = useGetBuildingThresholdsQuery(locationId);
    const fetchThresholdsError = error ? toErrorType(error) : undefined;

    if (fetchThresholdsError) {
        return <ResponseBox text={fetchThresholdsError.error} />;
    }

    return (
        <SpinnerBlocker isLoading={isLoading}>
            <div>
                {customThresholds.length > 0 && (
                    <div className={styles.customThresholds}>
                        <CustomThresholds
                            parentLocationId={locationId}
                            childResourceScope={ThresholdsResourceScope.SPACE}
                            headerTextKey="CustomThresholds.SpacesWithCustomThresholds"
                            customThresholds={customThresholds}
                        />
                    </div>
                )}
                <ThresholdMgmt
                    id={locationId}
                    thresholdScope={ThresholdsResourceScope.LOCATION}
                    parentThresholdScope={ThresholdsResourceScope.USER_GROUP}
                    thresholdData={data}
                    buttonText="ThresholdSettings.UpdateThresholds"
                />
            </div>
        </SpinnerBlocker>
    );
};

export default BuildingThresholds;
